import AudienceFilterResourceInstance from "../../../../resources/expapiunified/AudienceFilter.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  AudienceFilterResourceInstance,
  "audience-filters",
  (state) => state.audienceFilters
);
const { actions, epic, reducer, matchers, selectors, getDefaultReducerState } = builder.create();
const {
  getAsync: getAudienceFilterAsync,
  resetGetAsync: resetGetAudienceFilterAsync,
  createOrUpdateAsync: createOrUpdateAudienceFilterAsync,
  resetCreateOrUpdateAsync: resetCreateOrUpdateAudienceFilterAsync,
  deleteAsync: deleteAudienceFilterAsync,
  resetDeleteAsync: resetDeleteAudienceFilterAsync,
  queryAsync: queryAudienceFiltersAsync,
  resetQueryAsync: resetQueryAudienceFiltersAsync
} = actions;
const {
  selectGetAsyncRequest: selectGetAudienceFilterAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateAudienceFilterAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteAudienceFilterAsyncRequest,
  selectQueryAsyncRequest: selectQueryAudienceFiltersAsyncRequest,
  selectAll: selectAllAudienceFilters,
  selectById: selectAudienceFilterById
} = selectors;
export {
  epic as audienceFiltersEpic,
  matchers as audienceFiltersMatchers,
  reducer as audienceFiltersReducer,
  createOrUpdateAudienceFilterAsync,
  deleteAudienceFilterAsync,
  getAudienceFilterAsync,
  getDefaultReducerState as getDefaultAudienceFiltersReducerState,
  queryAudienceFiltersAsync,
  resetCreateOrUpdateAudienceFilterAsync,
  resetDeleteAudienceFilterAsync,
  resetGetAudienceFilterAsync,
  resetQueryAudienceFiltersAsync,
  selectAllAudienceFilters,
  selectAudienceFilterById,
  selectCreateOrUpdateAudienceFilterAsyncRequest,
  selectDeleteAudienceFilterAsyncRequest,
  selectGetAudienceFilterAsyncRequest,
  selectQueryAudienceFiltersAsyncRequest
};
//# sourceMappingURL=audience-filters.js.map
